import ActionOrderDetails from "../../DashboardReceivedOrders/ActiveOrders/ActionOrderDetails/ActionOrderDetails";

export default function ProductDetails() {
  return (
    <ActionOrderDetails />
  );
}
